module.exports = __webpack_public_path__ + "img/11Polk.6f60d518.png";